const NavbarItem = require('../NavbarItem')

class NavbarItemSlidingSubmenu extends NavbarItem {
  constructor(container) {
    super(container);
  }
  
  show(activationCallback) {
    if (this.isActive) return;
    super.show(activationCallback)


  }

  hide() {
    if (!this.isActive) return;
    super.hide()

  }
}

module.exports = NavbarItemSlidingSubmenu